var description = '_19j9mfx1';
var root = '_19j9mfx0';

export { description, root };
//# sourceMappingURL=checkbox.css.js.map
